const { default: PageName } = require('@/utils/defines/PageName')
const { default: RoutePath } = require('@/utils/modules/RoutePath')

const InviteRouter = [
	{
		path: RoutePath.invite.accept,
		name: PageName.Invite.Receive,
		component: () =>
			import(
				/* webpackChunkName: "lmpro-invite-invite-page" */ '@/views/invite/pages/ReceiveInvitePage.vue'
			),
	},
	{
		path: RoutePath.invite.expire,
		name: PageName.Invite.Expire,
		component: () =>
			import(
				/* webpackChunkName: "lmpro-license-expire-page" */ '@/views/invite/pages/LicenseExpirePage.vue'
			),
	},
	{
		path: RoutePath.invite.institute,
		name: PageName.Invite.Institute,
		component: () =>
			import(
				/* webpackChunkName: "lmpro-license-expire-page" */ '@/views/invite/pages/InviteMemberInst.vue'
			),
	},
	{
		path: RoutePath.auth.emailAuthentication,
		name: PageName.Auth.EmailAuthentication,
		component: () =>
			import(
				/* webpackChunkName: "lmpro-license-expire-page" */ '@/views/invite/pages/AuthEmailNotice.vue'
			),
	},
]

export default InviteRouter
